import { baseClone } from './base'
export default function clone(data) {
  return baseClone(data)
}
